import React, { useEffect } from "react";

type PageWithTitleProps = {
  defaultTitle: string;
  title: string;
};

function PageWithTitle({
  defaultTitle,
  title,
  children,
}: React.PropsWithChildren<PageWithTitleProps>) {
  useEffect(() => {
    document.title = title ? `${title} | ${defaultTitle}` : defaultTitle;
    return () => {
      document.title = defaultTitle;
    };
  }, [defaultTitle, title]);

  return <>{children}</>;
}

export default PageWithTitle;
